import { render, staticRenderFns } from "./connectgraduate.vue?vue&type=template&id=627258ef&scoped=true"
import script from "./connectgraduate.vue?vue&type=script&lang=js"
export * from "./connectgraduate.vue?vue&type=script&lang=js"
import style0 from "./connectgraduate.vue?vue&type=style&index=0&id=627258ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627258ef",
  null
  
)

export default component.exports